import { ParamConfig } from "../../engine/nodes/utils/params/ParamsConfig";
import { ColorConversion } from "../Color";
import { SphereBufferGeometry } from "three";
import { Vector3 } from "three";
import { Mesh } from "three";
import { LIGHT_HELPER_MAT } from "./_Base";
import { Color } from "three";
import { Vector2 } from "three";
export const DEFAULT_POINT_LIGHT_PARAMS = {
  color: new Color(1, 1, 1),
  intensity: 1,
  decay: 0.1,
  distance: 100,
  castShadow: false,
  shadowAutoUpdate: true,
  shadowUpdateOnNextRender: false,
  shadowRes: new Vector2(1024, 1024),
  shadowBias: 1e-3,
  shadowNear: 1,
  shadowFar: 100,
  showHelper: false,
  helperSize: 1
};
const DEFAULT = DEFAULT_POINT_LIGHT_PARAMS;
export function PointLightParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.light = ParamConfig.FOLDER();
      this.color = ParamConfig.COLOR(DEFAULT.color.toArray(), {
        conversion: ColorConversion.SRGB_TO_LINEAR
      });
      this.intensity = ParamConfig.FLOAT(DEFAULT.intensity, {
        range: [0, 10],
        rangeLocked: [true, false]
      });
      this.decay = ParamConfig.FLOAT(DEFAULT.decay, {
        range: [0, 1],
        rangeLocked: [true, false]
      });
      this.distance = ParamConfig.FLOAT(DEFAULT.distance, {
        range: [0, 100],
        rangeLocked: [true, false]
      });
      this.showHelper = ParamConfig.BOOLEAN(DEFAULT.showHelper);
      this.helperSize = ParamConfig.FLOAT(1, { visibleIf: { showHelper: 1 } });
      this.shadow = ParamConfig.FOLDER();
      this.castShadow = ParamConfig.BOOLEAN(DEFAULT.castShadow);
      this.shadowAutoUpdate = ParamConfig.BOOLEAN(DEFAULT.shadowAutoUpdate, {
        visibleIf: { castShadow: 1 }
      });
      this.shadowUpdateOnNextRender = ParamConfig.BOOLEAN(DEFAULT.shadowUpdateOnNextRender, {
        visibleIf: { castShadow: 1, shadowAutoUpdate: 0 }
      });
      this.shadowRes = ParamConfig.VECTOR2(DEFAULT.shadowRes.toArray(), { visibleIf: { castShadow: 1 } });
      this.shadowBias = ParamConfig.FLOAT(DEFAULT.shadowBias, { visibleIf: { castShadow: 1 } });
      this.shadowNear = ParamConfig.FLOAT(DEFAULT.shadowNear, { visibleIf: { castShadow: 1 } });
      this.shadowFar = ParamConfig.FLOAT(DEFAULT.shadowFar, { visibleIf: { castShadow: 1 } });
    }
  };
}
export class CorePointLightHelper {
  constructor() {
    this._material = LIGHT_HELPER_MAT.clone();
    this._matrixScale = new Vector3(1, 1, 1);
  }
  createObject() {
    return new Mesh();
  }
  createAndBuildObject(options) {
    const object = this.createObject();
    this.buildHelper(object);
    this.update(object, options);
    return object;
  }
  buildHelper(object) {
    const size = 1;
    object.geometry = new SphereBufferGeometry(size, 4, 2);
    object.matrixAutoUpdate = false;
    object.material = this._material;
    return object;
  }
  update(object, options) {
    const size = options.helperSize;
    this._matrixScale.set(size, size, size);
    object.matrix.identity();
    object.matrix.scale(this._matrixScale);
    this._material.color.copy(options.light.color);
  }
}
